import { jsx } from "react/jsx-runtime";
import { useColors } from "@inbody/core";
import { TextField, InputAdornment } from "@mui/material";
import { createInputFieldSx } from "../tokens.js";
function InputField({
  value,
  onChange,
  placeholder,
  minWidth,
  startIcon,
  endIcon,
  type = "text",
  multiline = false,
  minRows,
  maxRows,
  onKeyDown,
  onFocus,
  onBlur,
  autoFocus,
  name,
  onClick,
  inputProps,
  size = "md",
  radius,
  fullWidth = false,
  error = false,
  disabled = false,
  sx
}) {
  const { gray, brand } = useColors();
  const inputSx = createInputFieldSx({ gray, brand, size, radius, error });
  return /* @__PURE__ */ jsx(
    TextField,
    {
      name,
      type,
      value,
      multiline,
      minRows,
      maxRows,
      disabled,
      error,
      autoFocus,
      onChange: (e) => onChange(e.target.value),
      onKeyDown,
      onFocus,
      onBlur,
      onClick,
      placeholder,
      fullWidth,
      inputProps,
      sx: { ...inputSx, minWidth, ...sx },
      InputProps: {
        startAdornment: startIcon ? /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: startIcon }) : void 0,
        endAdornment: endIcon ? /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: endIcon }) : void 0
      }
    }
  );
}
export {
  InputField
};
